import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveBGImage from '../../Util/ResponsiveBGImage/ResponsiveBGImage';

// import assets
import './gridImagesModule.scss';


const GridImagesModuleView = (props) => {
  const images = props.images.map((image, index) => {
    let src = {
      sm: image.src['750'],
      md: image.src['400'],
      lg: image.src['620'],
      xl: image.src['445'],
      xxl: image.src['620'],
      xxxl: image.src['1020'],
      default: image.src.default,
    };

    if (index === 2) {
      src = {
        sm: image.src['750'],
        md: image.src['750'],
        lg: image.src['1600'],
        xl: image.src['1600'],
        xxl: image.src['1600'],
        xxxl: image.src['1900'],
        default: image.src.default,
      };
    }

    return (
      <div className={'m-grid-images-module__pic-wrapper'}>
        <ResponsiveBGImage
          className={'m-grid-images-module__pic'}
          src={src}
          alt={image.alt}
          imageCollection={props.images}
          collectionIndex={index}
        >
          <span className={'m-grid-images-module__pic-enum'}>{`//${index + 1}`}</span>
        </ResponsiveBGImage>
      </div>
    );
  });

  return (
    <div className="m-article-module">
      <div className={'m-grid-images-module'}>
        <div className={'m-grid-images-module__images'}>
          <div className="m-grid-images-module__image m-grid-images-module__image--smalls">
            {images[0]}
            {images[1]}
          </div>
          <div className="m-grid-images-module__image m-grid-images-module__image--big">
            {images[2]}
          </div>
        </div>
        <div className={'m-grid-images-module__descs'}>
          {props.images.map((image, index) => {
            const descIndex = `desc-${index}`;
            return (
              <span key={descIndex} className={'m-grid-images-module__img-desc'} dangerouslySetInnerHTML={{ __html: `//${index + 1} ${image.desc} ` }} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

GridImagesModuleView.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.shape(),
    alt: PropTypes.string,
    desc: PropTypes.string,
  })),
};

GridImagesModuleView.defaultProps = {
  images: [],
};

export default GridImagesModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/GridImagesModule/GridImagesModuleView.jsx